import { render, staticRenderFns } from "./qm-description.vue?vue&type=template&id=63da342f&scoped=true"
import script from "./qm-description.vue?vue&type=script&lang=js"
export * from "./qm-description.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63da342f",
  null
  
)

export default component.exports